import { useState } from "react";
import { Form } from "react-bootstrap";
import { Button } from "@mui/material";
import containerStyles from "utilities/styles/containerStyles.module.scss";
import styles from "features/slideShow/slideShow.module.scss";
import { useEditPhotoCommentMutation } from "app/api/media";

const EditCommentModal = ({ selectedComment, currentVerification, handleCloseModal }) => {
  const [newComment, setNewComment] = useState<string>("");
  const [editPhotoComment] = useEditPhotoCommentMutation();

  const saveEditComment = (e) => {
    e.preventDefault();

    editPhotoComment({
      checklistId: currentVerification.checklistId,
      mediaId: currentVerification.id,
      commentId: selectedComment.id,
      newComment: newComment,
    })
      .unwrap()
      .then(() => handleCloseModal());
  };

  return (
    <div className={containerStyles.overlay}>
      <div className={styles.writeComment}>
        <Form onSubmit={saveEditComment}>
          <p className="fw-bold text-dark my-2">Redigera kommentar</p>
          <Form.Control
            type="text"
            className="my-3"
            defaultValue={selectedComment?.text}
            onChange={(e) => setNewComment(e.target.value)}
          />

          <div className="d-flex justify-content-center mt-2">
            <Button variant="contained" color="error" onClick={handleCloseModal} className="me-2">
              Avbryt
            </Button>
            <Button variant="contained" type="submit" disabled={newComment === ""}>
              Spara
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default EditCommentModal;
